module.exports = __webpack_public_path__ + "static/media/variable_white.1629e173.svg";